import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import blockService from './blockService';

const initialState = {
  tiktokBlock: '',
  isTikTokBlockError: false,
  isTikTokBlockSuccess: false,
  isTikTokBlockLoading: false,
  isTikTokBlockErrorMsg: '',
};

export const creatingTikTokBlock = createAsyncThunk(
  'tiktokBlock/creatingTikTokBlock',

  async (headingkData, thunkAPI) => {
    try {
      const response = await blockService.creatingHeadingBlock(headingkData);
      return response;
    } catch (error) {
      const isTikTokBlockErrorMsg =
        (error.response && error.response.data && error.response.data.isTikTokBlockErrorMsg) ||
        error.isTikTokBlockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isTikTokBlockErrorMsg);
    }
  }
);
export const tikTokSlice = createSlice({
  name: 'tiktokBlock',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.isTikTokBlockLoading = false;
      state.isTikTokBlockSuccess = false;
      state.isTikTokBlockError = false;
      state.isTikTokBlockErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingTikTokBlock.pending, (state) => {
        state.isTikTokBlockLoading = true;
      })
      .addCase(creatingTikTokBlock.fulfilled, (state, action) => {
        state.isTikTokBlockLoading = false;
        state.isTikTokBlockSuccess = true;
        state.tiktokBlock = action.payload;
      })
      .addCase(creatingTikTokBlock.rejected, (state, action) => {
        state.isTikTokBlockLoading = false;
        state.isTikTokBlockError = true;
        state.isTikTokBlockErrorMsg = action.payload; // error from catch will come here via action.payload and update isTikTokBlockErrorMsg
      });
  },
});
export const { resetUser } = tikTokSlice.actions;
export default tikTokSlice.reducer;
